import React, { FC } from 'react';
import { Link } from 'gatsby';
import { Strong } from '../Strong';
import styled from 'styled-components';
import { rhythm } from '../../utils/typography';

type BreadcrumbProps = {
  pathname: string;
};

const getBreadcrumbsLinks = (pathname: string) =>
  pathname
    .split('/')
    .filter(path => !!path)
    .map((path, index, array) => {
      const link = !index ? path : array.slice(0, index + 1).join('/');
      return { link, breadcrumb: decodeURIComponent(path).replace('-', ' ') };
    });

const Slash = styled.span`
  font-size: ${rhythm(3 / 7)};
`;

export const Breadcrumb: FC<BreadcrumbProps> = ({ pathname }) => {
  const breadcrumbsLinks = getBreadcrumbsLinks(pathname);
  if (!breadcrumbsLinks.length) {
    return (
      <>
        <Slash>/</Slash>{' '}
        <Link to="/">
          <Strong>xyz</Strong>
        </Link>
      </>
    );
  }
  return (
    <>
      {breadcrumbsLinks.map(({ link, breadcrumb }) => (
        <span key={link}>
          <Slash>/</Slash>{' '}
          <Link to={`/${link}`}>
            <Strong>{breadcrumb}</Strong>
          </Link>{' '}
        </span>
      ))}
    </>
  );
};
